import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZApiSuccessResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.string(),
  error_message: z.optional(z.string())
})

export type ApiSuccessResponse = z.infer<typeof ZApiSuccessResponse>

export async function getRegularKekListHsmByFilterParameter (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  filterParams: any,
  onSuccess: (requestId: string, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  let field = sortfield
  if (field === 'created At') {
    field = 'createdAt'
  } else if (field === 'created By') {
    field = 'createdBy'
  }
  const url = `/app-config-service/api/v1/crypto/all-hsm-kek-details-async?page=${page}&size=${size}&sort=${field},${sortdir}`

  interceptedAxios
    .post(url, filterParams)
    .then((response) => {
      const parseResponse = ZApiSuccessResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, parseResponse.data.http_status)
        } else {
          onFailure({ totalCount: 0, group_details: [] }, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore next
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
